import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSwitch } from "@redotech/redo-web/switch";
import { Text } from "@redotech/redo-web/text";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const productSyncFieldsForm = groupInput({
  tags: input<boolean>(),
  title: input<boolean>(),
  sku: input<boolean>(),
});

export type ProductSyncFieldsForm = InputSchema.Input<
  typeof productSyncFieldsForm
>;

export type ProductSyncFieldsValue = InputSchema.Value<
  typeof productSyncFieldsForm
>;

export const productSyncFieldsDefault: ProductSyncFieldsValue = {
  tags: false,
  title: false,
  sku: false,
};

export const ProductSyncFieldsCard = memo(function ProductSyncFieldsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  const { productSyncFields } = input.inputs;

  return (
    <Card title="Product Update Sync Fields" w="full">
      <Flex dir="column" gap="md">
        <Text fontSize="sm">
          Select which additional product fields should be synced when products
          are updated in Shopify. When enabled, changes to these fields will
          update existing OMS fulfillment groups.
        </Text>
        <Text fontSize="xs" textColor="tertiary">
          The following fields are always synced: bin, barcode, weight, and
          received status.
        </Text>
        <FormSwitch input={productSyncFields.inputs.tags} label="Sync tags" />
        <FormSwitch input={productSyncFields.inputs.title} label="Sync title" />
        <FormSwitch input={productSyncFields.inputs.sku} label="Sync SKU" />
      </Flex>
    </Card>
  );
});
